<template>
  <div class="demo-cw">
    <div class="main">
      <LessonCourseware :class-type-id="classTypeId" :lesson-id="lessonId" />
    </div>
    <div class="btns">
      <a-button @click="changeIds">
        切换课件
      </a-button>
    </div>
  </div>
</template>
<script>
import LessonCourseware from '@/components/Courseware/LessonCourseware.vue'
export default {
  components: {
    LessonCourseware
  },
  data() {
    return {
      classTypeId: 1,
      lessonId: 2
    }
  },
  methods: {
    changeIds() {
      this.classTypeId = this.classTypeId + 1
      this.lessonId = this.lessonId + 1
    }
  }
}
</script>
<style lang="less" scoped>
.demo-cw {
  display: flex;
  height: 80vh;
  .main {
    flex: 1;
  }
  .btns {
    width: 200px;
    margin: 10px;
    padding: 0 10px;
    border-left: 1px solid #9e9e9e;
  }
}
</style>